import {
  addBillChannelApi,
  deleteBillChannelApi,
  getBillChannelListApi,
  batchSetBrandRelConfigApi,
  setShopMsgApi,
  getShopApi,
  getTableAreaListApi,
  getDeskCardListApi,
  addTableAreaApi,
  updateTableAreaApi,
  saveDeskCardApi,
  deleteTableAreaApi,
  deleteDeskCardApi,
  deskCardBatchSortApi,
  updateShopRadioConfigApi,
  getFreightListApi,
  saveOrUpdateFreightApi,
  deleteFreightApi,
  addDadaBrandApi,
  addDadaShopApi,
  bindDadaShopApi,
  setPrinterUniversalConfigApi,
  getPrinterUniversalConfigApi,
  getCompanyForPlatformByIdApi,
  queryBrandForPlatformApi,
  addBrandCategoryApi,
  updateBrandCategoryApi,
  queryBrandCategoryApi,
  setCategoryByBrandIdApi,
  updateBaseBrandApi,
  setBrandMsgApi,
  updateBrandApi,
  updateBalanceUseValiCodeApi,
  setBrandConfigApi,
  getWechatAccountListApi,
  getPushModeAndMsgModeListApi,
  setMsgModeApi,
  addWechatNoticeBindApi,
  deleteWechatNoticeBindApi,
  getWechatNoticeBindListApi,
  bindShopForKdNiaoApi,
  addElectronicSheetTemplateApi,
  updateElectronicSheetTemplateApi,
  deleteElectronicSheetTemplateApi,
  updateElectronicSheetTemplateIsDefaultApi,
  queryElectronicSheetTemplateListApi,
  queryElectronicSheetTemplateByIdApi,
  queryElectronicSheetOrderListApi,
  queryElectronicSheetPrintOrderApi,
  orderOnlineKdNiaoApi,
  sortBrandCategoryApi,
  queryIndustryApi,
  queryWaiterEvaluatesApi,
  addEvalWaitersApi,
  deleteWaiterEvaluateApi,
  batchSetCompanyRelConfigApi,
  saveCompanyCustomConfigApi,
  getCompanyCustomConfigApi,
  queryLongitudeLatitudeApi,
  saveOrUpdateLongitudeLatitudeApi,
  queryAgentCompanyApi,
  deleteLongitudeLatitudeApi,
  updateShopAutoApi,
  saveOrUpdateAccountOutApi,
  queryAccountOutApi,
  saveOrUpdateAccountInApi,
  queryAccountInApi,
  queryAccountWaterApi,
  getBrandUserCountByCondApi,
  addStaffWorkBandoverApi,
  queryBrandUserHandoverApi,
  queryStaffWorkBandoverApi,
  setAptitudeAuthentApi,
  addShareShopApi,
  addBrandRelShareShopApi,
  setBrandShopRelMsgApi,
  getShareShopListApi,
  queryShareShopApi,
  queryBrandShopRelByBrandApi,
  queryBrandShopRelByShopApi,
  addReserveFundApi,
  saveOrUpdateFreightRuleApi,
  getFreightRuleListApi,
  deleteFreightRuleApi,
  getFreightRuleByIdApi,
  setFreightRuleEnableApi,
  getErrandConfigApi,
  setErrandConfigApi,
  ylyAddPrinterApi,
  ylyGetPrintStatusApi,
  queryShopsGxApi,
  addWechatAutoReplyConfigApi,
  updateWechatAutoReplyConfigApi,
  getWechatAutoReplyConfigByConditApi,
  applyForRefundApi,
  getShopRelBrandListApi,
  getShopByIdApi,
  setMainShopApi,
  queryHftxFwsApi,
  queryAliPersonalAccountApi,
  saveOrUpdateAliPersonalAccountApi,
  queryShopOverlordMealListApi,
  setShopOverlordMealTaskApi,
  getStaffListForPlatApi,
  saveOrUpdateTbkInfoApi,
  getTbkInfoByForeignKeyIdApi,
  queryElmPidsApi,
  exportElmPidsApi,
  setCompanyExtendConfigApi,
  saveOrUpdatePosterApi,
  delPosterByIdApi,
  queryPostersApi,
  queryBrandUserFormApi,
  deleteSupplierByIdApi,
  deleteSupplierShopByIdApi,
  saveOrUpdateBwcConfigApi,
  queryBwcConfigApi,
  setBrandCustomConfigFieldMsgApi,
  getGxCompanyProfitStatisticsApi,
  getShopInitStaffAccountApi,
  getBrandCategoryMidListApi,
  getCurCompanyAllFunctionTemplateListApi,
  getFormTableListApi
} from '@/api'
import { RES_OK } from '@/config'
const state = {}
const getters = {}
const mutations = {}
const actions = {
  //  保存支付挂账渠道信息
  async addBillChannelAction(context, param) {
    const res = await addBillChannelApi(param)
    return res
  },
  //  保存支付挂账渠道信息
  async deleteBillChannelAction(context, param) {
    const res = await deleteBillChannelApi(param)
    return res
  },
  //  获取支付挂账渠道列表
  async getBillChannelListAction(context, param) {
    const res = await getBillChannelListApi(param)
    return res
  },
  //  批量设置品牌相关配置
  async batchSetBrandRelConfigAction(context, param) {
    const res = await batchSetBrandRelConfigApi(param)
    return res
  },
  //  设置门店信息
  async setShopMsgAction(context, param) {
    const res = await setShopMsgApi(param)
    return res
  },
  //  获取门店信息
  async getShopAction(context, param) {
    const res = await getShopApi(param)
    return res
  },
  //  设置门店区域信息
  async getTableAreaListAction(context, param) {
    const res = await getTableAreaListApi(param)
    return res
  },
  //  设置门店桌号列表信息
  async getDeskCardListAction(context, param) {
    const res = await getDeskCardListApi(param)
    return res
  },
  //  保存餐台区域
  async addTableAreaAction(context, param) {
    const res = await addTableAreaApi(param)
    return res
  },
  //  修改餐台区域
  async updateTableAreaAction(context, param) {
    const res = await updateTableAreaApi(param)
    return res
  },
  //  删除餐台区域
  async deleteTableAreaAction(context, param) {
    const res = await deleteTableAreaApi(param)
    return res
  },
  //  保存桌号
  async saveDeskCardAction(context, param) {
    const res = await saveDeskCardApi(param)
    return res
  },
  //  删除桌号
  async deleteDeskCardAction(context, param) {
    const res = await deleteDeskCardApi(param)
    return res
  },
  // 桌牌号批量排序
  async deskCardBatchSortAction(context, param) {
    const res = await deskCardBatchSortApi(param)
    return res
  },
  // 更改门店的shopRadionConifg
  async shopRadioConfigAction(context, param) {
    const res = await updateShopRadioConfigApi(param)
    return res
  },
  //  获取指定门店配送设置列表
  async getFreightListAction(context, param) {
    const res = await getFreightListApi(param)
    return res
  },
  // 新增/更新配送信息
  async saveOrUpdateFreightAction(context, param) {
    const res = await saveOrUpdateFreightApi(param)
    return res
  },
  // 删除同城配送信息
  async deleteFreightAction(context, param) {
    const res = await deleteFreightApi(param)
    return res
  },
  // 添加达达申请账号
  async addDadaBrandAction(context, param) {
    const res = await addDadaBrandApi(param)
    return res
  },
  // 删除同城配送信息
  async addDadaShopAction(context, param) {
    const res = await addDadaShopApi(param)
    return res
  },
  // 绑定门店
  async bindDadaShopAction(context, param) {
    const res = await bindDadaShopApi(param)
    return res
  },
  // 小票打印机配置
  async setPrinterUniversalConfigAction(context, param) {
    const res = await setPrinterUniversalConfigApi(param)
    return res
  },
  // 小票打印机配置
  async getPrinterUniversalConfigAction(context, param) {
    const res = await getPrinterUniversalConfigApi(param)
    return res
  },
  // 小票打印机配置
  async getCompanyForPlatformByIdAction(context, param) {
    const res = await getCompanyForPlatformByIdApi(param)
    return res
  },
  // 小票打印机配置
  async queryBrandForPlatformAction(context, param) {
    const res = await queryBrandForPlatformApi(param)
    return res
  },
  // 新增品牌类型
  async addBrandCategoryAction(context, param) {
    const res = await addBrandCategoryApi(param)
    return res
  },
  // 更新品牌类型
  async updateBrandCategoryAction(context, param) {
    const res = await updateBrandCategoryApi(param)
    return res
  },
  // 查询品牌类型
  async queryBrandCategoryAction(context, param) {
    const res = await queryBrandCategoryApi(param)
    return res
  },
  // 设置品牌的分类
  async setCategoryByBrandIdAction(context, param) {
    const res = await setCategoryByBrandIdApi(param)
    return res
  },
  // 设置品牌的logo
  async updateBaseBrandAction(context, param) {
    const res = await updateBaseBrandApi(param)
    return res
  },
  // 设置品牌信息
  async setBrandMsgAction(context, param) {
    const res = await setBrandMsgApi(param)
    return res
  },
  // 更新品牌信息
  async updateBrandAction(context, param) {
    const res = await updateBrandApi(param)
    return res
  },
  // 设置余额支付短信验证码
  async updateBalanceUseValiCodeAction(context, param) {
    const res = await updateBalanceUseValiCodeApi(param)
    return res
  },
  // 设置品牌config
  async setBrandConfigAction(context, param) {
    const res = await setBrandConfigApi(param)
    return res
  },
  // 获取公众号和小程序信息
  async getWechatAccountListAction(context, param) {
    const res = await getWechatAccountListApi(param)
    return res
  },
  // 获取消息推送和消息模板列表
  async getPushModeAndMsgModeListAction(context, param) {
    const res = await getPushModeAndMsgModeListApi(param)
    return res
  },
  // 设置消息模板信息
  async setMsgModeAction(context, param) {
    const res = await setMsgModeApi(param)
    return res
  },
  // 添加微信通知绑定
  async addWechatNoticeBindAction(context, param) {
    const res = await addWechatNoticeBindApi(param)
    return res
  },
  // 删除微信通知绑定
  async deleteWechatNoticeBindAction(context, param) {
    const res = await deleteWechatNoticeBindApi(param)
    return res
  },
  // 获取微信通知绑定列表信息
  async getWechatNoticeBindListAction(context, param) {
    const res = await getWechatNoticeBindListApi(param)
    return res
  },
  // 绑定门店相关快递鸟信息
  async bindShopForKdNiaoAction(context, param) {
    const res = await bindShopForKdNiaoApi(param)
    return res
  },
  // 添加电子面单模板
  async addElectronicSheetTemplateAction(context, param) {
    const res = await addElectronicSheetTemplateApi(param)
    return res
  },
  // 修改电子面单模板
  async updateElectronicSheetTemplateAction(context, param) {
    const res = await updateElectronicSheetTemplateApi(param)
    return res
  },
  // 删除电子面单模板
  async deleteElectronicSheetTemplateAction(context, param) {
    const res = await deleteElectronicSheetTemplateApi(param)
    return res
  },
  // 修改电子面单模板为默认
  async updateElectronicSheetTemplateIsDefaultAction(context, param) {
    const res = await updateElectronicSheetTemplateIsDefaultApi(param)
    return res
  },
  // 查询电子面单模板列表
  async queryElectronicSheetTemplateListAction(context, param) {
    const res = await queryElectronicSheetTemplateListApi(param)
    return res
  },
  // 查询电子面单模板对应id的详情信息
  async queryElectronicSheetTemplateByIdAction(context, param) {
    const res = await queryElectronicSheetTemplateByIdApi(param)
    return res
  },
  // 查询电子面单相关的订单列表信息
  async queryElectronicSheetOrderListAction(context, param) {
    const res = await queryElectronicSheetOrderListApi(param)
    return res
  },
  // 获取打印电子面单相关参数
  async queryElectronicSheetPrintOrderAction(context, param) {
    const res = await queryElectronicSheetPrintOrderApi(param)
    return res
  },
  // 快递鸟电子面单
  async orderOnlineKdNiaoAction(context, param) {
    const res = await orderOnlineKdNiaoApi(param)
    return res
  },
  // 品牌行业排序
  async sortBrandCategoryAction(context, param) {
    const res = await sortBrandCategoryApi(param)
    return res
  },
  //  获取运维行业信息
  async queryIndustryAction(context, param) {
    const res = await queryIndustryApi(param)
    return res
  },
  //  员工评价列表
  async queryWaiterEvaluatesAction(context, param) {
    const res = await queryWaiterEvaluatesApi(param)
    return res
  },
  //  新增可评价员工
  async addEvalWaitersAction(context, param) {
    const res = await addEvalWaitersApi(param)
    return res
  },
  //  删除评价
  async deleteWaiterEvaluateAction(context, param) {
    const res = await deleteWaiterEvaluateApi(param)
    return res
  },
  //  批量设置公司相关配置
  async batchSetCompanyRelConfigAction(context, param) {
    const res = await batchSetCompanyRelConfigApi(param)
    return res
  },
  //  保存公司自定义配置
  async saveCompanyCustomConfigAction(context, param) {
    const res = await saveCompanyCustomConfigApi(param)
    return res
  },
  //  获取公司自定义配置
  async getCompanyCustomConfigAction(context, param) {
    const res = await getCompanyCustomConfigApi(param)
    return res
  },
  //  上门服务区域
  async queryLongitudeLatitudeAction(context, param) {
    const res = await queryLongitudeLatitudeApi(param)
    return res
  },
  //  上门服务区域——新增/更新经纬度
  async saveOrUpdateLongitudeLatitudeAction(context, param) {
    const res = await saveOrUpdateLongitudeLatitudeApi(param)
    return res
  },
  //  查询被代理公司
  async queryAgentCompanyAction(context, param) {
    const res = await queryAgentCompanyApi(param)
    return res
  },
  //  删除经纬度
  async deleteLongitudeLatitudeAction(context, param) {
    const res = await deleteLongitudeLatitudeApi(param)
    return res
  },
  //  修改门店自动化配置
  async updateShopAutoAction(context, param) {
    const res = await updateShopAutoApi(param)
    return res
  },
  //  新增/修改出账账户
  async saveOrUpdateAccountOutAction(context, param) {
    const res = await saveOrUpdateAccountOutApi(param)
    return res
  },
  //  分页查询出账账户
  async queryAccountOutAction(context, param) {
    const res = await queryAccountOutApi(param)
    return res
  },
  //  新增/修改入账账户
  async saveOrUpdateAccountInAction(context, param) {
    const res = await saveOrUpdateAccountInApi(param)
    return res
  },
  //  分页查询入账账户
  async queryAccountInAction(context, param) {
    const res = await queryAccountInApi(param)
    return res
  },
  //  查询账户流水
  async queryAccountWaterAction(context, param) {
    const res = await queryAccountWaterApi(param)
    return res
  },
  //  根据条件统计品牌用户数
  async getBrandUserCountByCondAction(context, param) {
    const res = await getBrandUserCountByCondApi(param)
    return res
  },
  //  添加员工工作交接
  async addStaffWorkBandoverAction(context, param) {
    const res = await addStaffWorkBandoverApi(param)
    return res
  },
  //  查看品牌用户交接记录
  async queryBrandUserHandoverAction(context, param) {
    const res = await queryBrandUserHandoverApi(param)
    return res
  },
  //  查询员工工作交接
  async queryStaffWorkBandoverAction(context, param) {
    const res = await queryStaffWorkBandoverApi(param)
    return res
  },
  //  设置资质认证
  async setAptitudeAuthentAction(context, param) {
    const res = await setAptitudeAuthentApi(param)
    return res
  },
  //  添加共享门店
  async addShareShopAction(context, param) {
    const res = await addShareShopApi(param)
    return res
  },
  //  添加品牌关联共享门店
  async addBrandRelShareShopAction(context, param) {
    const res = await addBrandRelShareShopApi(param)
    return res
  },
  //  设置品牌门店关联信息
  async setBrandShopRelMsgAction(context, param) {
    const res = await setBrandShopRelMsgApi(param)
    return res
  },
  //  获取共享门店列表
  async getShareShopListAction(context, param) {
    const res = await getShareShopListApi(param)
    return res
  },
  //  查询共享门店
  async queryShareShopAction(context, param) {
    const res = await queryShareShopApi(param)
    return res
  },
  //  根据品牌查询品牌门店关联
  async queryBrandShopRelByBrandAction(context, param) {
    const res = await queryBrandShopRelByBrandApi(param)
    return res
  },
  //  根据门店查询品牌门店关联
  async queryBrandShopRelByShopAction(context, param) {
    const res = await queryBrandShopRelByShopApi(param)
    return res
  },
  //  添加储备金
  async addReserveFundAction(context, param) {
    const res = await addReserveFundApi(param)
    return res
  },
  //  新增/修改配送设置规则
  async saveOrUpdateFreightRuleAction(context, param) {
    const res = await saveOrUpdateFreightRuleApi(param)
    return res
  },
  //  查询配送设置规则
  async getFreightRuleListAction(context, param) {
    const res = await getFreightRuleListApi(param)
    return res
  },
  //  删除配送设置规则
  async deleteFreightRuleAction(context, param) {
    const res = await deleteFreightRuleApi(param)
    return res
  },
  //  根据id查询配送设置规则
  async getFreightRuleByIdAction(context, param) {
    const res = await getFreightRuleByIdApi(param)
    return res
  },
  //  设置配送设置规则启用
  async setFreightRuleEnableAction(context, param) {
    const res = await setFreightRuleEnableApi(param)
    return res
  },
  //  获取跑腿配置
  async getErrandConfigAction(context, param) {
    const res = await getErrandConfigApi(param)
    return res
  },
  //  设置跑腿配置
  async setErrandConfigAction(context, param) {
    const res = await setErrandConfigApi(param)
    return res
  },
  //  把打印机添加到易联云应用中
  async ylyAddPrinterAction(context, param) {
    const res = await ylyAddPrinterApi(param)
    return res
  },
  //  打印机在易联云平台的状态
  async ylyGetPrintStatusAction(context, param) {
    const res = await ylyGetPrintStatusApi(param)
    return res
  },
  //  查询门店信息
  async queryShopsGxActions(context, param) {
    const res = await queryShopsGxApi(param)
    return res
  },
  //  添加微信自动回复配置
  async addWechatAutoReplyConfigAction(context, param) {
    const res = await addWechatAutoReplyConfigApi(param)
    return res
  },
  //  更新微信自动回复配置
  async updateWechatAutoReplyConfigAction(context, param) {
    const res = await updateWechatAutoReplyConfigApi(param)
    return res
  },
  //  根据条件查询微信自动回复配置
  async getWechatAutoReplyConfigByConditAction(context, param) {
    const res = await getWechatAutoReplyConfigByConditApi(param)
    return res
  },
  //  申请退款
  async applyForRefundAction(context, param) {
    const res = await applyForRefundApi(param)
    return res
  },
  //  获取门店关联的品牌列表
  async getShopRelBrandListAction(context, param) {
    const res = await getShopRelBrandListApi(param)
    return res
  },
  //  根据id获取门店信息
  async getShopByIdAction(context, param) {
    const res = await getShopByIdApi(param)
    return res
  },
  //  设置总店
  async setMainShopAction(context, param) {
    const res = await setMainShopApi(param)
    return res
  },
  //  分页查询服务商
  async queryHftxFwsAction(context, param) {
    const res = await queryHftxFwsApi(param)
    return res
  },
  //  查询支付宝信息
  async queryAliPersonalAccountAction(context, param) {
    const res = await queryAliPersonalAccountApi(param)
    return res
  },
  //  新增/更新支付宝账户信息
  async saveOrUpdateAliPersonalAccountAction(context, param) {
    const res = await saveOrUpdateAliPersonalAccountApi(param)
    return res
  },
  //  获取霸王餐门店对应列表
  async queryShopOverlordMealListAction(context, param) {
    const res = await queryShopOverlordMealListApi(param)
    return res
  },
  //  设置霸王餐活动
  async setShopOverlordMealTaskAction(context, param) {
    const res = await setShopOverlordMealTaskApi(param)
    return res
  },
  //  获取员工列表信息(用于平台)
  async getStaffListForPlatAction(context, param) {
    const res = await getStaffListForPlatApi(param)
    return res
  },
  //  新增/更新淘宝账号信息
  async saveOrUpdateTbkInfoAction(context, param) {
    const res = await saveOrUpdateTbkInfoApi(param)
    return res
  },
  //  根据外键（品牌）id获取淘宝客信息
  async getTbkInfoByForeignKeyIdAction(context, param) {
    const res = await getTbkInfoByForeignKeyIdApi(param)
    return res
  },
  //  饿了么pid查询
  async queryElmPidsAction(context, param) {
    const res = await queryElmPidsApi(param)
    return res
  },
  //  饿了么pid导入
  async exportElmPidsAction(context, param) {
    const res = await exportElmPidsApi(param)
    return res
  },
  //  设置公司扩展配置(json对象)
  async setCompanyExtendConfigAction(context, param) {
    const res = await setCompanyExtendConfigApi(param)
    return res
  },
  //  新增/更新海报接口
  async saveOrUpdatePosterAction(context, param) {
    const res = await saveOrUpdatePosterApi(param)
    return res
  },
  //  根据id删除海报接口
  async delPosterByIdAction(context, param) {
    const res = await delPosterByIdApi(param)
    return res
  },
  //  查询海报
  async queryPostersAction(context, param) {
    const res = await queryPostersApi(param)
    return res
  },
  //  查询自定义表单数据
  async queryBrandUserFormAction(context, param) {
    const res = await queryBrandUserFormApi(param)
    return res
  },
  //  根据id删除供应商
  async deleteSupplierByIdAction(context, param) {
    const res = await deleteSupplierByIdApi(param)
    return res
  },
  //  根据id删除供应商门店
  async deleteSupplierShopByIdAction(context, param) {
    const res = await deleteSupplierShopByIdApi(param)
    return res
  },
  //  新增或者更新配置信息
  async saveOrUpdateBwcConfigAction(context, param) {
    const res = await saveOrUpdateBwcConfigApi(param)
    return res
  },
  //  配置查询
  async queryBwcConfigAction(context, param) {
    const res = await queryBwcConfigApi(param)
    return res
  },
  //  设置品牌自定义字段信息
  async setBrandCustomConfigFieldMsgAction(context, param) {
    const res = await setBrandCustomConfigFieldMsgApi(param)
    return res
  },
  //  获取高校公司收益统计
  async getGxCompanyProfitStatisticsAction(context, param) {
    const res = await getGxCompanyProfitStatisticsApi(param)
    return res
  },
  //  获取门店初始员工账号
  async getShopInitStaffAccountAction(context, param) {
    const res = await getShopInitStaffAccountApi(param)
    return res
  },
  //  获取品牌分类关联列表
  async getBrandCategoryMidListAction(context, param) {
    const res = await getBrandCategoryMidListApi(param)
    return res
  },
  //  获取当前公司下所有菜单模板列表
  async getCurCompanyAllFunctionTemplateListAction(context, param) {
    const res = await getCurCompanyAllFunctionTemplateListApi(param)
    return res
  },
  //  获取自定义表单列表
  async getFormTableListAction({ getters }) {
    let param = {
      brandId: getters.brandInfo.id
    }
    const res = await getFormTableListApi(param)
    if (res.Code === RES_OK) {
      let list = res.Result || []
      return list
    }
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}
